import $ from 'jquery';

$(function() {
    let animating = false;
    let cardsCounter = 1;
    const $numOfCards = $('.card').length;
    const decisionVal = 80;
    let pullDeltaX = 0;
    let pullDeltaY = 0;
    let posX = 0;
    let posY = 0;
    let $card;
    let $cardReject;
    let $cardLike;

    function pullChange() {
        animating = true;
        posX = pullDeltaX - 125;
        posY = pullDeltaY;
        if (window.innerWidth >= 768) {
            $card.attr('style', `transform: translateX(${posX}px) translateY(${posY}px) !important; transition: scale 0.3s !important;`);
        } else {
            $card.attr('style', `transform: translateX(${posX}px) translateY(70px) !important; transition: scale 0.3s !important;`);
        }
        const opacity = pullDeltaX / 100;
        const rejectOpacity = (opacity >= 0) ? 0 : Math.abs(opacity);
        const likeOpacity = (opacity <= 0) ? 0 : opacity;
        $cardReject.css('opacity', rejectOpacity);
        $cardLike.css('opacity', likeOpacity);
    }

    function release() {
        if (pullDeltaX >= decisionVal) {
            $card.addClass('to-right');
        } else if (pullDeltaX <= -decisionVal) {
            $card.addClass('to-left');
        }

        if (Math.abs(pullDeltaX) >= decisionVal) {
            $card.addClass('inactive');

            setTimeout(function() {
                $card.addClass('below').removeClass('inactive to-left to-right current');
                $card.attr('data-index', $numOfCards + 1);
                $card.prev('.card').addClass('current');
                $('.card').each(function() {
                    const dataIndex = $(this).attr('data-index');
                    if (dataIndex > 1) {
                        $(this).attr('data-index', parseInt(dataIndex, 10) - 1);
                    }
                });
                cardsCounter += 1;
                if (cardsCounter > $numOfCards) {
                    cardsCounter = 1;
                    $('.card').removeClass('below');
                    $('.card').last().addClass('current');
                }
            }, 200);
        }

        if (Math.abs(pullDeltaX) < decisionVal) {
            $card.addClass('reset');
        }

        setTimeout(function() {
            $card.attr('style', '').removeClass('reset')
                .find('.card__choice').attr('style', '');

            pullDeltaX = 0;
            animating = false;
        }, 200);
    }
    function reverseRelease() {
        if ($card.next().attr('data-index') === undefined) {
            $('.card').first().addClass('previous');
        } else {
            $card.next().addClass('previous');
        }

        if (Math.abs(pullDeltaX) >= decisionVal) {
            if ($card.next().attr('data-index') === undefined) {
                $('.card').first().addClass('inactive');
            } else {
                $card.next().addClass('inactive');
            }

            setTimeout(function() {
                $card.removeClass('to-left to-right previous inactive current');
                if ($card.next().attr('data-index') === undefined) {
                    $('.card').first().attr('data-index', 0);
                    $('.card').first().addClass('current').removeClass('previous inactive');
                } else {
                    $card.next().addClass('current').removeClass('below previous inactive');
                    $card.next().attr('data-index', 0);
                }
                $('.card').each(function() {
                    const dataIndex = $(this).attr('data-index');
                    if (dataIndex < $numOfCards) {
                        $(this).attr('data-index', parseInt(dataIndex, 10) + 1);
                    }
                });
                cardsCounter -= 1;
                if (cardsCounter < 1) {
                    cardsCounter = $numOfCards;
                    $('.card').addClass('below');
                    $('.card').removeClass('current previous inactive');
                    $('.card').first().addClass('current').removeClass('below');
                }
            }, 200);
        }
    }

    $(document).on('mousedown touchstart', '.current:not(.inactive)', function(e) {
        if (animating) return;
        $card = $(this);
        $cardReject = $('.card-choice.m-reject', $card);
        $cardLike = $('.card-choice.m-like', $card);
        const startX = e.pageX || e.originalEvent.touches[0].pageX;
        const startY = e.pageY || e.originalEvent.touches[0].pageY;

        $(document).on('mousemove touchmove', function(ev) {
            const x = ev.pageX || ev.originalEvent.touches[0].pageX;
            const y = ev.pageY || ev.originalEvent.touches[0].pageY;
            pullDeltaX = (x - startX);
            pullDeltaY = (y - startY);
            if (!pullDeltaX) return;
            pullChange();
        });

        $(document).on('mouseup touchend', function() {
            $(document).off('mousemove touchmove mouseup touchend');
            if (!pullDeltaX) return; // prevents from rapid click events
            release();
        });
    });
    $('.btn-next').on('click', function() {
        $card = $('.current');
        pullDeltaX = decisionVal + 1;
        if (!pullDeltaX) return;
        release();
    });
    $('.btn-prev').on('click', function() {
        $card = $('.current');
        pullDeltaX = -decisionVal - 1;
        if (!pullDeltaX) return;
        reverseRelease();
    });
});
